import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { useRef } from "react";

// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Popper, Tooltip } from "@crehana/ui";
import cn from "clsx";
import SubMenuDesktopLink from "./SubMenuDesktopLink";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var MenuCollapsableLink = function MenuCollapsableLink(_ref) {
  var route = _ref.route,
    isDark = _ref.isDark,
    isSelected = _ref.isSelected,
    isOpened = _ref.isOpened,
    _ref$subRoutes = _ref.subRoutes,
    subRoutes = _ref$subRoutes === void 0 ? [] : _ref$subRoutes,
    currentRoute = _ref.currentRoute,
    setIsOpenEnd = _ref.setIsOpenEnd,
    onSelectNestedRoute = _ref.onSelectNestedRoute,
    isSidebarV2Enabled = _ref.isSidebarV2Enabled;
  var buttonCollapsedRef = useRef(null);
  var hasNestedRoutes = subRoutes.length > 0;
  var ActiveIcon = route.activeIcon || route.icon;
  var getTopPositionElement = function getTopPositionElement() {
    var buttonCollapsed = buttonCollapsedRef.current;
    if (!buttonCollapsed) {
      return 0;
    }
    var _buttonCollapsed$getB = buttonCollapsed.getBoundingClientRect(),
      top = _buttonCollapsed$getB.top;
    return top;
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Tooltip, {
      position: "right",
      isDark: isDark,
      label: route.tooltip || route.label,
      children: /*#__PURE__*/_jsx("button", {
        type: "button",
        className: "w-full",
        ref: buttonCollapsedRef,
        onClick: function onClick() {
          return setIsOpenEnd(function (prev) {
            return !prev;
          });
        },
        children: /*#__PURE__*/_jsx("div", {
          className: cn('flex items-center justify-center w-48 h-48 mx-auto my-4 rounded-5', isDark ? 'hover:bg-gray-lighter-dark-mode' : 'hover:bg-gray-lighter', {
            'bg-gray-lighter text-primary-main shadow-tooltip': isSelected && !isDark,
            'text-gray-dark': !isSelected && !isDark,
            'text-secondary-main bg-gray-main-dark-mode shadow-tooltip': isSelected && isDark,
            'text-gray-main': !isSelected && isDark
          }),
          children: isOpened ? /*#__PURE__*/_jsx(ActiveIcon, {
            size: isSidebarV2Enabled ? 20 : 24,
            className: "fill-current",
            ignoreColor: true
          }) : /*#__PURE__*/_jsx(route.icon, {
            size: isSidebarV2Enabled ? 20 : 24,
            className: "fill-current",
            ignoreColor: true
          })
        })
      })
    }), hasNestedRoutes && /*#__PURE__*/_jsx(Popper, {
      anchorRef: buttonCollapsedRef,
      isVisible: isOpened,
      isDark: isDark,
      position: "right",
      dismissOnClickOutside: true,
      className: "flex",
      onDismiss: function onDismiss() {
        setIsOpenEnd(false);
      },
      setPosition: function setPosition(s) {
        var top = getTopPositionElement();
        return _objectSpread(_objectSpread({}, s), {}, {
          left: 112,
          top: top
        });
      },
      children: /*#__PURE__*/_jsx("div", {
        className: "p-12",
        children: /*#__PURE__*/_jsx("ul", {
          className: "block w-full pt-4",
          children: subRoutes.map(function (subRoute) {
            return /*#__PURE__*/_jsx(SubMenuDesktopLink, {
              route: subRoute,
              isDark: isDark,
              decorationType: "none",
              isSelectedURL: (currentRoute === null || currentRoute === void 0 ? void 0 : currentRoute.key) === subRoute.key,
              onClick: function onClick() {
                onSelectNestedRoute(subRoute);
                setIsOpenEnd(false);
              }
            }, subRoute.key);
          })
        })
      })
    })]
  });
};
export default MenuCollapsableLink;